<script>
import Vue from 'vue';
import {required, email} from 'vuelidate/lib/validators'
import {mapState, mapActions} from 'vuex';
import PreloaderItem from '../PreloaderItem/PreloaderItem.vue';
import SelectLanguage from '../SelectLanguage/SelectLanguage.vue';

export default Vue.extend({
    components: {
        PreloaderItem,
        SelectLanguage
    },
    data () {
        return {
            email: undefined
        }
    },
    validations: {
        email: {
            required,
            email
        }
    },
    computed: {
        ...mapState({
            loading: state => state.auth.forgot.loading,
            message: state => state.auth.forgot.message
        }),
        emailClasses () {
            return {
                'forgot-password-page__input--error': this.$v.email.$dirty && this.$v.email.$error,
                'forgot-password-page__input--success': this.$v.email.$dirty && !this.$v.email.$error
            }
        }
    },
    methods: {
        ...mapActions({
            forgotPassword: 'auth/forgotPassword'
        }),
        submit () {
            this.$v.$touch();

            if (!this.$v.email.$error) {
                this.forgotPassword({
                    email: this.email
                });
            }
        }
    }
});
</script>
<template>
    <div class="forgot-password-page">
        <div class="forgot-password-page__heading">{{ $t('forgotPassword.heading') }}</div>
        <div class="forgot-password-page__paragraph">{{ $t('forgotPassword.description') }}</div>
        <div v-if="message" :class="`forgot-password-page__alert--${message.level}`" class="forgot-password-page__alert">
            {{ $t(message.text) }}
        </div>
        <div class="forgot-password-page__form">
            <div class="forgot-password-page__input-group">
                <input :placeholder="$t('forgotPassword.email.placeholder')"
                       v-model="email"
                       :class="emailClasses"
                       type="email"
                       class="forgot-password-page__input"
                       @input="$v.email.$touch()"
                       @keyup.enter="submit">
                <span v-if="$v.email.$dirty && !$v.email.required" class="forgot-password-page__input-help">{{ $t('forgotPassword.email.errors.required') }}</span>
                <span v-if="$v.email.$dirty && !$v.email.email" class="forgot-password-page__input-help">{{ $t('forgotPassword.email.errors.email') }}</span>
            </div>
            <div class="forgot-password-page__input-group">
                <button :disabled="loading" class="forgot-password-page__submit" @click="submit" @keyup.enter="submit">
                    <span v-if="!loading">{{ $t('forgotPassword.button') }}</span>
                    <preloader-item v-if="loading"/>
                </button>
            </div>
        </div>
        <router-link to="/" class="forgot-password-page__sign-in-link">{{ $t('forgotPassword.signInLink') }}</router-link>
        <select-language/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ForgotPasswordPage/ForgotPasswordPage.vue